import { t } from "ttag";

import { EmptyState } from "@/shared/ui";

export const ChartEmpty = () => {
  return (
    <EmptyState.Root>
      <EmptyState.Title>{t`No entries for this period yet`}</EmptyState.Title>
      <EmptyState.Description>
        {t`Record your weight entry with the “Log data” button to begin tracking your progress.`}
      </EmptyState.Description>
    </EmptyState.Root>
  );
};
